import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { ListItemProps, Typography } from "@mui/material";

export interface SearchElementType {
  id?: string;
  name: string;
  newName?: string;
}

const filter = createFilterOptions({
  matchFrom: "any",
  stringify: (option: SearchElementType) => option.name,
});

interface DynamicSearchSelectProps {
  label: string;
  required: boolean;
  options: SearchElementType[];
  selectedOptionId: string | null;
  helperText?: string;
  loading: boolean;
  onChange: (
    event: React.SyntheticEvent<Element, Event>,
    newInputValue: SearchElementType | null
  ) => void;
  onInputChange: (
    event: React.SyntheticEvent<Element, Event>,
    newInputValue: string
  ) => void;
  onNewElementAdded: (newElement: SearchElementType) => void;
}

// TODO: verify generic type
const DynamicSearchSelect = ({
  label,
  required,
  options,
  selectedOptionId,
  helperText,
  loading,
  onChange,
  onInputChange,
  onNewElementAdded,
}: DynamicSearchSelectProps) => {
  // Trova il valore corrente dalle opzioni
  const value = React.useMemo(() => {
    return selectedOptionId 
      ? options.find((op) => op.id == selectedOptionId) || null
      : null;
  }, [selectedOptionId, options]);

  return (
    <>
      <Autocomplete
        value={value}
        options={options}
        disablePortal
        size="small"
        loading={loading}
        loadingText={<Typography>Caricamento ...</Typography>}
        fullWidth
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(event, newValue) => {
          if (!newValue) {
            // cleared
          } else if (newValue && newValue.id) {
            // Selezionato un valore dalla lista
            onChange(event, newValue);
          } else {
            if (newValue && newValue?.newName) {
              // Creazione nuovo elemento
              let newElement = {
                name: newValue?.newName,
              };
              onNewElementAdded(newElement);
            }
          }
        }}
        onInputChange={(event, newInputValue, reason) => {
          onInputChange(event, newInputValue);
        }}
        filterOptions={(options, params) => {
          const { inputValue } = params;
          
          // Filtra normalmente
          let filtered = filter(options, params);

          const isExisting = options.some(
            (option) => inputValue === option.name
          );
          if (inputValue !== "" && !isExisting) {
            filtered.push({
              name: `Aggiungi "${inputValue}"`,
              newName: inputValue,
            });
          }

          return filtered;
        }}
        handleHomeEndKeys
        id="dynamic-searchable-combo-box"
        noOptionsText="Nessun dato disponibile"
        getOptionLabel={(option) => {
          if (option.newName) {
            return option?.newName;
          }
          return option.name;
        }}
        renderOption={(
          props: React.HTMLAttributes<HTMLLIElement> & ListItemProps,
          option
        ) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              {option.name}
            </li>
          );
        }}
        renderInput={(params: any) => (
          <TextField
            required={required || false}
            // error={required && !value}
            helperText={helperText || ""}
            fullWidth
            {...params}
            label={label}
          />
        )}
      />
    </>
  );
};

export default DynamicSearchSelect;
